import { initialEventState, createEmptyAttendedDate, createEmptyArtist } from './eventDefaults'

export const transformEventForEdit = (eventData) => {
  return {
    ...initialEventState,
    ...eventData,
    startDate: eventData.startDate ? eventData.startDate.split('T')[0] : '',
    endDate: eventData.endDate ? eventData.endDate.split('T')[0] : '',
    attendedDates: (eventData.attendedDates || []).map(dateItem => ({
      date: dateItem.date ? new Date(dateItem.date).toISOString().split('T')[0] : '',
      description: dateItem.description || ''
    })),
    additionalDates: (eventData.additionalDates || [createEmptyAttendedDate()]).map(dateItem => ({
      date: dateItem.date ? new Date(dateItem.date).toISOString().split('T')[0] : '',
      description: dateItem.description || ''
    })),
    artistsSeen: (eventData.artistsSeen || [createEmptyArtist()]).map(artist => ({
      ...artist,
      performanceDate: artist.performanceDate ? new Date(artist.performanceDate).toISOString().split('T')[0] : ''
    }))
  }
}

export const createFormData = (event, mediaFiles = []) => {
  const formData = new FormData()

  Object.entries(event).forEach(([key, value]) => {
    // Skip null and undefined values to avoid "null" string issues
    if (value === null || value === undefined) {
      return
    }

    // Skip empty strings for optional fields that shouldn't be sent
    // (but keep them for text fields that might legitimately be empty)
    if (value === '' && ['rating', 'notes', 'lineup', 'favoritePerformance'].includes(key)) {
      return
    }

    if (typeof value === 'object') {
      formData.append(key, JSON.stringify(value))
    } else {
      formData.append(key, value)
    }
  })

  mediaFiles.forEach((file) => {
    formData.append('media', file)
  })

  return formData
}